export const SCAM_LINK_STATUS = 'SCAM_LINK_STATUS';